import { compact, get } from 'lodash-es';
import { getBedLengthValue } from 'site-modules/shared/utils/features-format';
import { isPickupType } from 'site-modules/shared/utils/is-pickup-type';
import { toSentenceCase } from 'client/utils/string-utils';
import { getPlural } from 'client/utils/plural';

export function getEngineAttr({ vehicleInfo, showElectricityRange }) {
  const electricityRange = get(vehicleInfo, 'partsInfo.electricityRange', '');

  if (showElectricityRange) {
    return electricityRange ? `${electricityRange} mi range` : '';
  }

  const bodyType = get(vehicleInfo, 'styleInfo.bodyType');
  const isPickup = isPickupType(bodyType);
  const engineSize = get(vehicleInfo, 'partsInfo.engineSize');
  const cylinders = get(vehicleInfo, 'partsInfo.cylinders');
  const transmission = get(vehicleInfo, 'partsInfo.transmission', '');
  const bedLength = getBedLengthValue(get(vehicleInfo, 'partsInfo.bedLengthMeasurement'));
  const numberOfSeats = get(vehicleInfo, 'styleInfo.numberOfSeats');
  const epaCityMPG = get(vehicleInfo, 'styleInfo.fuel.epaCityMPG');
  const epaHighwayMPG = get(vehicleInfo, 'styleInfo.fuel.epaHighwayMPG');

  switch (bodyType) {
    case 'SUV':
      return compact([
        numberOfSeats && `${numberOfSeats} ${getPlural('Seat', numberOfSeats)}`,
        compact([epaCityMPG && `${epaCityMPG} City`, epaHighwayMPG && `${epaHighwayMPG} Hwy MPG`]).join(' / '),
        transmission.toLowerCase() === 'manual' && `${toSentenceCase(transmission)}`,
      ]).join(', ');
    case 'Sedan':
    case 'Hatchback':
      return compact([
        compact([epaCityMPG && `${epaCityMPG} City`, epaHighwayMPG && `${epaHighwayMPG} Hwy MPG`]).join(' / '),
        transmission.toLowerCase() === 'manual' && `${toSentenceCase(transmission)}`,
      ]).join(', ');

    case 'Minivan':
    case 'Station Wagon':
    case 'Full Size Van':
      return compact([
        numberOfSeats && `${numberOfSeats} ${getPlural('Seat', numberOfSeats)}`,
        compact([epaCityMPG && `${epaCityMPG} City`, epaHighwayMPG && `${epaHighwayMPG} Hwy MPG`]).join(' / '),
      ]).join(', ');

    default:
      return toSentenceCase(
        compact([
          isPickup && bedLength && `${bedLength} Bed`,
          isPickup && engineSize && `${engineSize}L`,
          cylinders && `${cylinders}cyl`,
          !isPickup && transmission,
        ]).join(isPickup && bedLength ? ', ' : ' ')
      );
  }
}
